export type PartyType = 'PERSON' | 'COMPANY';

export interface Party {
  id: string;
  partyType: PartyType;
  customerSegmentCode: string;
  person: Person;
  company: Company;
  registrationAddress: Address;
  englishRegistrationAddress: Address;
  deliveryAddress: Address;
  englishDeliveryAddress: Address;
  consents: PartyConsent[];
}

export interface Person {
  id?: string;
  customerSegmentCode?: string;
  nationality: string;
  nationalId: number;
  passportNumber: string;
  gender: string;
  title: string;
  firstName: string;
  lastName: string;
  firstNameTh: string;
  lastNameTh: string;
  birthDate: string;
  occupation: string;
  email: string;
  mobileNumber: string;
}

export interface Company {
  id?: string;
  customerSegmentCode?: string;
  registrationNumber: string;
  companyPrefix: string;
  companySuffix: string;
  companyName: string;
  companyNameTh: string;
  companySuffixTh: string;
  mainBranch: boolean;
  branch: string;
  businessTypeCode: string;
  contactName: string;
  email: string;
  mobileNumber: string;
}

export interface Address {
  addressId?: string;
  addressLine1: string; // AddressNo
  addressLine2: string; // Moo
  addressLine3: string; // Soi
  addressLine4: string; // Road

  countryCode: string;
  provinceCode: string;
  districtCode: string;
  subDistrictCode: string;
  zipCode: string;
}

export interface PartyConsent {
  consentId: string;
  consentFlag: boolean;
}
